import axios from 'axios';

import { API_URI } from '../config';

export default axios.create({
    baseURL: API_URI,
});
// use interceptors,
// will work to refresh token in the background
export const axiosPrivate = axios.create({
    baseURL: API_URI,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});
